import React, { useEffect, useState } from "react"
import UserSession from "../../../utils/userSessionClass";
// import CustomSelect from '../../../common/CustomSelect';
// import { DepositSummary } from "./depositSummary";

export const WithDrawDeposit = ({
  cashDrawerId,
  cashDrawerName,
  checkStatus,
  options,
  date,
  onChange,
  systemBalance  
}) => {
  const [rows, setRows] = useState([]);
  const userSession = new UserSession();
  const sessionVals = userSession.getSessionValues();
  const cashierName = sessionVals?.employeeName;
  useEffect(() => {
    if (!systemBalance) {
      setRows([]);
      return;
    }

    const newRows = systemBalance.map(item => ({
      currency: item.currencyCode,
      systemValue: item.amount,
      // by default we can assign draw value as system value.
      drawValue: item.amount,
      discrepancy: false,
      withDrawAmount: 0,
      finalValue: 0,
      remarks: ''
    }));

    setRows(newRows);
  }, [systemBalance]);

  const [errors,] = useState({});

  useEffect(() => {
    if (!cashDrawerId || !date) return;
  }, [cashDrawerId, date]);

  const updateRow = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;

    const system = Number(updated[index].systemValue);
    const draw = Number(updated[index].drawValue || 0);

    const isDiscrepancy = system !== draw;

    updated[index].discrepancy = isDiscrepancy;
  

    setRows(updated);
    onChange?.(updated);
  };




  return (
    <div className="checkin-grid-wrapper " style={{ overflowX: 'auto'}}>
      <div className="flexRow justifyContentFlexStart">
         <div className={`dialog__container_item input-container`}>
            <div className={`dialog__description`}>
              <label className={'req'}>Cashier Name</label>
              <input
                contentEditable={false}
                disabled={true}
                type={'text'}
                className='edit-input'
                value={cashierName}
              />
            </div>

          </div>
              <div className={`dialog__container_item input-container margLeft6`}>
            <div className={`dialog__description`}>
              <label className={'req'}>Drawer Name</label>
              <input
                contentEditable={false}
                disabled={true}
                type={'text'}
                className='edit-input'
                value={cashDrawerName}
              />
            </div>

          </div>



      </div>
       <div className={`dialog__container_item input-container`}>
            <div className={`dialog__description`}>
              <label className={''}>WithDrawal Date & Time :{new Date().toLocaleString()}</label>
            
            </div>

          </div>
      <table>
        <thead>
          <tr>
            <th>Currency Code</th>
            <th>System Value</th>
            <th>Draw Value</th>
            <th>Discrepancy</th>
            <th>Withdraw Amount</th>
            <th>Final Value</th>
            <th>Remarks</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((r, i) => (
            <tr key={r.currency}>
              <td>{r.currency}</td>
              <td>{r.systemValue.toFixed(2)}</td>

              <td style={{width:'15%'}}>
                <input
                  className="edit-input"
                  type="number"
                  value={r.drawValue}
                  onChange={(e) =>
                    updateRow(i, "drawValue", e.target.value)
                  }
                />
              </td>
 <td>
                  <input
                type="checkbox"
                checked={!!r.discrepancy}
                className="currency-active-checkbox"
              />


              </td>
             <td style={{width:'15%'}}>
                <input
                  type="number"
                  className="edit-input"
                  value={r.withDrawAmount}
                  onChange={(e) =>
                    updateRow(i, "withDrawAmount", e.target.value)
                  }
                />
              </td>
              <td style={{width:'15%'}}>
                <input
                  type="number"
                  className="edit-input"
                  value={r.finalValue}
                  onChange={(e) =>
                    updateRow(i, "finalValue", e.target.value)
                  }
                />
              </td>

             

              <td>
                <input
                  className="edit-input"
                  type="text"
                  disabled={!r.discrepancy}
                  value={r.remarks}
                  onChange={(e) =>
                    updateRow(i, "remarks", e.target.value)
                  }
                />
                {errors[i] && (
                  <div className="error-text">{errors[i]}</div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
     
      
    </div>
  );
};
